import buyProduct from "@assets/images/homepage/redesign/buy-product.webp";
import { type PurchaseAssuranceIconKind } from "@/blueprint/components/PurchaseAssuranceIcon/PurchaseAssuranceIcon";

type BuyPanelBullet = {
  body: string;
  icon: PurchaseAssuranceIconKind;
  title: string;
};

export const BUY_PANEL = {
  title: "Buy Matic",
  price: "From $1,495",
  priceNoteLabel: "A note on pricing",
  ctaLabel: "Shop",
  href: "/product",
  productImage: buyProduct,
  productImageAlt: "The Matic robot",
  bullets: [
    {
      icon: "return",
      title: "6 months to decide",
      body: "Live with Matic for six months. If you don’t love it, return for a full refund.",
    },
    {
      icon: "shipping",
      title: "Free shipping & returns",
      body: "We cover shipping both ways in the contiguous U.S.",
    },
    {
      icon: "warranty",
      title: "1-year warranty",
      body: "Covered for a year, with U.S.-based support when you need it.",
    },
  ] satisfies readonly BuyPanelBullet[],
};
